module.exports = __webpack_public_path__ + "img/ubi.94b5c1e3.svg";